import { createContext } from 'react'

export const ListingProfileContext = createContext()
